import { useState } from 'react';
import RegisterModal from '../landing/RegisterModal';
import Button from '../layout/Button';
import PricingGrid from './PricingGrid';


export default function PricingCard() {

  const [showRegisterModal, setShowRegisterModal] = useState<boolean>(false);

  return (
    <>
      <RegisterModal show={showRegisterModal} setShow={setShowRegisterModal} />

      {/* `md:max-w-[48rem]`, not `md:w-[48rem]`. 48rem *is* the md breakpoint, so
          the moment md applied this card was pinned to exactly the viewport width
          while its caller wraps it in `w-2/3` — a 768px box inside a 506px one,
          overflowing the page by ~250px at that width. A max-width caps it on
          large screens without forcing it wider than its parent. */}
      <div className="mx-0 md:mx-auto w-full md:max-w-[48rem] bg-dark-blue rounded-6xl grid grid-cols-1 relative">

        {/* Text */}
        <div className="flex justify-start items-start flex-col pb-0 px-8 py-8 lg:px-12 text-left">
          <h2 className="text-xl sm:text-2xl sm:text-4xl xl:text-5xl font-semibold text-white">Join our growing community</h2>

          <p className="text-xs sm:text-base md:text-lg text-white font-light">
            Save your favourites, explore curated collections, and see ratings.
          </p>

          <Button
            onClick={() => setShowRegisterModal(true)}
            className="mt-8 mr-auto"
            width="fit"
          >
            <span className="">Join now</span>
          </Button>
        </div>

        {/* Pricing comparison */}
        <PricingGrid />

        {/* Bubble image */}
        <img
          src="/img/graphics/bubbles/bubble-top-orange.svg"
          alt="Bubble"
          className="absolute bottom-0 -right-20 sm:-right-28 w-28 sm:w-40 z-10"
        />
      </div>
    </>
  )
}
